import { onBeforeMount, ref } from '@vue/composition-api';
import { BannerConfig } from '@tencent/wphk-components-banner';
import { queryInfoFromDp, formatBannerData } from '@/business/dp-query';


/** 投放页面id */
const DP_PAGE = '110004000035';
/** 投放位置id */
const DP_POSITION = '1100040000350001';
// /** 投放页面id */
// const DP_PAGE = '110004599066';
// /** 投放位置id */
// const DP_POSITION = '1100045990660001';

export const useAdBnanner = () => {
  const bannerList = ref<BannerConfig[]>([]);
  async function init() {
    bannerList.value = await queryInfoFromDp(DP_PAGE, DP_POSITION, formatBannerData);
  }
  onBeforeMount(async () => {
    init();
  });
  return {
    bannerList,
    init,
  };
};
